require('../modules/es7.global');
module.exports = require('../modules/_core').global;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/global.js
// module id = sgJ5
// module chunks = 0